import _ from 'lodash'
import React from 'react'

import { Field, reduxForm } from 'redux-form'

const DefectAreaAddDialog = props => {
    const { handleSubmit, submitting, onSubmit, setIsAddDefectArea, mainAreaId, errors } = props
    console.log('MainAreaDialog props:', props)
    return (
        <div>
            <div className="br-pagebody">
                <div className="br-section-wrapper">
                    <form onSubmit={handleSubmit((values) => {
                        onSubmit(_.merge({
                            mainAreaId,
                        }, values))
                    })}>
                        <div className="row align-items-center justify-content-center defect-area-add-dialog">
                            <div className="card col-md-12">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group row">
                                                <label htmlFor="name" className="col-sm-4 form-control-label form-label-custom">บริเวณที่เกิดข้อบกพร่อง : <span className="tx-danger">&nbsp;*</span></label>
                                                <div className="col-sm-6">
                                                    <Field name="name" component="input" type="text" placeholder="Defect Area" className="form-control"/>
                                                    {errors ? <span className="text-danger">{errors.name}</span> : undefined}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br/>
                                    <div className="row float-right">
                                        <button type="submit" className="btn btn-dark" disabled={submitting}>ตกลง</button>
                                        <span>&nbsp;&nbsp;&nbsp;</span>
                                        <button type="button" className="btn btn-light" disabled={submitting}
                                                onClick={() => {setIsAddDefectArea(false, 'defectArea')}}>
                                            ปิด
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default  reduxForm({
    form: 'defect-area-add-dialog',
    enableReinitialize: true,
})(DefectAreaAddDialog)


// WEBPACK FOOTER //
// ./src/components/DefectAreaAddDialog.js